<template>
  <div class="aboutus">
    <!--头部关于我们标题-->
    <Header></Header>
    <div class="bg-top">
      <img src="../../static/img/17d759f.png" alt="">
      <div class="bg-top-title">
        <div class="text">共同进化&nbsp;&nbsp;&nbsp;增值分享</div>
      </div>
    </div>
    <!-- 公司介绍 -->
    <div class="profile">
      <div class="company-work">
        <div class="company-text1">
          关于泛物
        </div>
        <div class="company-text2">
          <img src="../../static/img/jiantou.png" alt="">
          <div class="text">
            <div class="text-w">泛物生态的组织构架由泛物能源、泛物云计算机、泛物水务及泛物网络4家公司组成，员工96人，其中专科以上文凭86人，本科以上文凭43人。目前本公司由数位博士硕士牵头开发完成购售电管理平台、企业能耗监控管理平台、工业园区综合能源管理平台、城市管网智能检测诊断平台及泛物盒子等20余个软硬件系统平台。并是宝德计算机-全系列产品大中华区总代理、中国电子长城股份-军品部特许经销商。服务售电企业372家，管理电量2100亿千瓦时，服务用能企业1万家，用能企业物联网化目标为20万家。

            </div>
          </div>
          <img class="r-img" src="../../static/img/8ffa32a.png" alt="">
        </div>
      </div>
    </div>
    <!-- 意愿 -->
    <div class="desire">
      <div class="company-work">
        <div class="company-text1">
          公司业务
        </div>
        <img src="../../static/img/jiantou.png" alt="">
        <div class="text-w">河南省泛物网络科技有限公司
          主要运营综合能源监控管理平台将大数据存储、分析、应用及云计算方面的技术与物联网通讯、设备远程智能维护服务有效结合。应用于能源行业、工业企业、工业园区等相关领域，对能源仪表及设备实时监控和控制，实现对生产过程的精细化管理，进一步规范企业能源管理，降低耗能，提高生产效率。

        </div>
      </div>
    </div>
    <!--企业简介-->
    <!-- <div class="company-profile">
      <img src="/static/img/1111.jpg" />
      <div>
        <h2>企业简介</h2>
        <p>
          泛物生态的组织构架由泛物能源、泛物云计算机、泛物水务及泛物网络4家公司组成，
          员工96人，其中专科以上文凭86人，本科以上文凭43人。
          目前本公司由数位博士硕士牵头开发完成购售电管理平台、企业能耗监控管理平台、
          工业园区综合能源管理平台、城市管网智能检测诊断平台及泛物盒子等11个软硬件系统平台。
        </p>
      </div>
    </div> -->
    <!--团队介绍-->
    <div class="team-introduction" >
      <div>
        <h2 style="margin-bottom: 30px;">团队介绍</h2>
        <!--<p>以“开放共享，合作共赢”为方向，助力“两化融合”及“中国制造2025”，推动物联网产业链相关产品的广泛应用，促进物联网各行业合作伙伴的交流与协作，构建合作共赢的物联网生态圈。</p>-->
      </div>
      <ul>
        <li v-for="(item,index) in teamArr" :key="index">
          <img :src="item.imgSrc" />
          <p>{{item.title}}</p>
          <span id="productId">{{item.introduction}}</span>
        </li>
      </ul>
    </div>
    <!--联系我们-->
    <div class="contact" >
      <div class="contact-top">
        <h2>联系我们</h2>
        <el-table :data="tableData" border style="width: 80%;margin:20px 0 0 10%;align-content: center;">
          <el-table-column prop="name" label="联系人"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="email" label="邮箱"></el-table-column>
          <el-table-column prop="address" label="业务范围"></el-table-column>
        </el-table>
      </div>
      <div class="contact-btm">
        <h2>完善您的需求期待与您合作</h2>
        <form action>
          <div>
            <div class="consulting">姓名:</div>
            <br />
            <input type="text" name="username" id="username" value="name" v-model="name" placeholder="请输入您的姓名" style="width: 460px;" />
          </div>
          <div>
            <div class="consulting">手机号：</div>
            <br />
            <input type="tel" name="phone" id="tel" value="phone" v-model="phone" placeholder="请输入您的手机号" style="width: 460px;" />
          </div>
          <div>
            <div class="consulting">公司名称：</div>
            <br />
            <input type="text" name="companyname" id="companyname" value="company" v-model="company" placeholder="请输入您的公司名称"
              style="width: 460px;" />
          </div>
          <div>
            <div class="consulting">所在地区：</div>
            <br />
            <input type="text" name="address" id="addresss" value="address" v-model="address" placeholder="请输入您的公司所在地区"
              style="width: 460px;" />
          </div>
          <div>
            <input type="radio" name="isFree" id="isFree" v-model="isFree" placeholder="申请终身免费使用售电管理平台" @click="controlSingel($event)"
              style="width: 30px;" />申请终身免费使用售电管理平台
            <br />
            <div class="consulting">咨询内容：</div>
            <br />
            <textarea name="advisory" rows="5" cols="169" value="content" v-model="content" placeholder="请输入咨询内容"></textarea>
          </div>
        </form>
        <div class="conceal" v-if="errorList.length > 0">
          <p>{{errorList.join(',')}}</p>
        </div>
        <div class="sub">
          <el-button type="primary" @click="onSub()">提交</el-button>
        </div>
      </div>
    </div>
    <Footer @func="getlocal"></Footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        teamArr: [{
            imgSrc: "/static/img/org_avator.png",
            title: "王鸿泰",
            introduction: "复旦大学电子通信专业， 高级电气工程师  泛物售电行业发展联盟主席",
          },
          {
            imgSrc: "/static/img/org_avator.png",
            title: "张学武",
            introduction: "天津党校经济学专业，高级通信工程师 高级电气工程师 泛物生态开发负责人",
          },
          {
            imgSrc: "/static/img/org_avator.png",
            title: "徐明明",
            introduction: "河北科技大学计算机专业，高级网络工程师，泛物网络工程总监，物联网云平台负责人。",
          },
          {
            imgSrc: "/static/img/org_avator.png",
            title: "武建国",
            introduction: "河北工业大学机械电子专业，高级电气工程师，供水管网自主潜航器及检测系统项目开发总监。",
          },
        ],
        tableData: [{
            name: " 袁阳光",
            phone: "15138950367 ",
            email: "fww@fanwuwang.com",
            address: " ",
          },
          {
            name: " ",
            phone: " ",
            email: " ",
            address: "",
          },
          {
            name: " ",
            phone: " ",
            email: " ",
            address: "",
          },
          {
            name: " ",
            phone: " ",
            email: " ",
            address: "",
          },
        ],
        name: "",
        phone: "",
        company: "",
        address: "",
        content: "",
        isFree: 1,
        errorList: [],
        changed: true,
      };
    },
    methods: {
      onSub() {
        if (this.isFree) {
          this.isFree = 1;
        } else {
          this.isFree = 0;
        }
        let obj = {
          name: this.name,
          phone: this.phone,
          company: this.company,
          area: this.address,
          content: this.content,
          isFree: this.isFree,
        };
        //			console.log(obj)
        this.$http
          .post("/api/websitemanager_v1/ApiController/addInfo", obj)
          .then((res) => {
            console.log(res);
            if (res.body.code == 200) {
              this.errorList = ["您的信息已提交成功，我们会尽快处理！"];
              this.name = "";
              this.phone = "";
              this.company = "";
              this.address = "";
              this.content = "";
              this.isFree = 1;
            } else {
              this.errorList = [res.body.msg];
            }
          });

        // this.name = "";
        // this.phone = "";
        // this.company = "";
        // this.address = "";
        // this.content = "";
        // this.isFree = 1;
      },
      controlSingel($event) {
        console.log(this.changed, "--09988--");
        if (this.changed) {
          $event.target.checked = true;
          this.changed = false;
          this.isFree = 1;
        } else {
          $event.target.checked = false;
          this.changed = true;
          this.isFree = 0;
        }
        console.log($event.target.checked, "--000--");
        console.log(this.isFree);
      },
      handleSub() {},
      //从我本地找到id
      getlocal() {
        //找到锚点id
        let selectId = localStorage.getItem("toId");
        let toElement = document.getElementById(selectId);
        //如果对应id存在，就跳转
        if (selectId) {
          toElement.scrollIntoView()
          localStorage.setItem("toId", '')
        }
      }
    },
    created() {
      //创建时执行跳转锚点位置
      if(this.$route.query.info){
        this.$nextTick(() => {
          this.getlocal()
        })
      }
    },
    mounted() {

    },

  };
</script>

<style scoped="scoped" lang="scss">
  .aboutus {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  /*头部关于我们标题*/
  .bg-top {
    width: 100%;
    height: 450px;
    background-size: 100% 100%;
    color: #000;
    text-align: center;
    font-size: 40px;
    line-height: 338px;
    position: relative;

    img {
      width: 100%;
    }

    .bg-top-title {
      position: absolute;
      top: 10%;
      left: 20%;
      width: 1128px;
      margin: 0 auto;

      .text {
        width: 50%;
        font-size: 36px;
        color: #fff;
      }
    }
  }

  /*公司介绍*/
  .profile {
    width: 1200px;
    margin: 0 auto;

    .company-work {
      padding: 70px 0;
      overflow: hidden;

      .company-text1 {
        width: 16.6%;
        height: 200px;
        line-height: 200px;
        font-size: 32px;
        color: #333;
        float: left;
      }

      .company-text2 {
        float: left;
        width: 83.3%;

        img {
          float: left;
        }

        .r-img {
          width: 29.16667%;
          margin: -20px;
        }

        .text {
          float: left;
          width: 66.66667%;
          padding-left: 20px;
          line-height: 26px;
          font-size: 14px;
          color: #666;
          margin-top: 48px;

          .text-w {
            width: 93%;
          }
        }
      }
    }

  }

  .desire {
    margin-top: 10px;
    padding: 70px 0;
    background-color: #ebebeb;

    .company-work {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .company-text1 {
        width: 16.6%;
        height: 200px;
        line-height: 200px;
        font-size: 32px;
        color: #333;
        float: left;
      }

      img {
        float: left;
      }

      .text-w {
        float: left;
        width: 76%;
        padding-left: 20px;
        line-height: 26px;
        font-size: 14px;
        color: #666;
        margin-top: 66px;
      }
    }
  }

  /*团队介绍*/

  .team-introduction {
    padding: 100px;

    div {
      width: 600px;
      margin: 0 auto;
      text-align: center;

      p {
        width: 600px;
        text-align: center;
        margin-top: 30px;
      }
    }

    ul {
      width: 80%;
      margin-left: 10%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      li {
        display: flex;
        margin-top: 20px;
        flex-direction: column;
        align-items: center;
        width: 220px;

        img {
          width: 230px;
          height: 230px;
          border-radius: 50%;
        }

        p {
          margin: 20px 0 10px;
          font-size: 18px;
        }

        span {
          color: #666;
          font-size: 14px;
        }
      }
    }
  }

  /*联系我们*/

  .contact {
    width: 80%;
    margin-left: 10%;

    h2 {
      text-align: center;
    }

    >>>.el-table td,
    .el-table th {
      padding: 20px 0;
    }

    >>>.has-gutter tr th {
      background: #e7e7e7;
    }

    .contact-btm {
      input {
        border: none;
        outline: none;
        border: 1px solid #ccc;
        border-radius: 2px;
        font-size: 14px;
        padding-left: 20px;
        /*width:460px;*/
        margin-bottom: 30px;
        margin-top: 10px;
      }

      textarea {
        border: none;
        outline: none;
        border: 1px solid #ccc;
        border-radius: 2px;
        font-size: 14px;
        padding-left: 20px;
      }

      form {
        padding-top: 50px;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        .consulting {
          padding-left: 0px;
          margin-bottom: -10px;
        }

        div {
          width: 50%;
          box-sizing: border-box;
          padding-left: 145px;
        }
      }

      .sub {
        width: 100px;
        margin: 30px auto 50px;
      }

      h2 {
        margin-top: 30px;
      }
    }
  }

  .conceal {
    width: 550px;
    height: 30px;
    border: 1px solid red;
    border-radius: 5px;
    margin: auto;
    margin-top: 10px;
    background-color: #f27474;

    p {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/aboutus.vue